import React from 'react';
import { connect } from 'react-redux';
import { sendSocketEmit } from 'actions';
import { Row, Col } from 'react-bootstrap';
import Dotdotdot from 'react-dotdotdot';
import { Link } from 'react-router';
import { ConfirmationPrompt } from 'components';
import moment from 'moment';

class TasksSidebarList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      current_task_id: null,
      current_hovered_task_id: null,
      show_delete_task_prompt: false
    };

    this.initEditTask = this.initEditTask.bind(this);
    this.toggleTaskComplete = this.toggleTaskComplete.bind(this);
    this.promptDeleteTask = this.promptDeleteTask.bind(this);
    this.handleDeleteTask = this.handleDeleteTask.bind(this);
    this.renderTask = this.renderTask.bind(this);
    this.handleClickTask = this.handleClickTask.bind(this);
  }

  initEditTask(task) {
    this.props.initEditTask(task);
  }
  toggleTaskComplete(task) {
    const payload = { ...task, completed: task.completed ? false : true };
    this.props.sendSocketEmit(payload, 'edit-task');
  }
  promptDeleteTask(task_id) {
    this.setState({ current_task_id: task_id, show_delete_task_prompt: true });
  }
  handleDeleteTask() {
    this.props.sendSocketEmit({ task_id: this.state.current_task_id }, 'task-delete');
    this.setState({ current_task_id: null, show_delete_task_prompt: false });
  }
  handleClickTask(task_id) {
    if(this.state.current_task_id == task_id) {
      this.setState({ current_task_id: null });
    }
    else {
      this.setState({ current_task_id: task_id });
    }
  }
  renderTask(task) {
    const { name } = this.props.show_assigned_by_me ? task.assigned_to || {} : task.assigned_by || {};
    let user_name;
    if(
      (!name || !name.first || name.first == '') &&
      (!name || !name.last || name.last == '')
    ) {
      user_name = '(No Name)';
    }
    else if(this.props.users.user._id == this.props.show_assigned_by_me ? task.assigned_to._id : task.assigned_by._id) {
      user_name = 'Self';
    }
    else {
      user_name = `${name.first || ''} ${name.last}`;
    }

    return (
      <li
        key={task._id}
        className='tasks-sidebar-task'
        style={{ marginBottom: '10px' }}
        onMouseOver={() => setTimeout(() => this.setState({ current_hovered_task_id: task._id }), 10)}
        onMouseLeave={() => this.setState({ current_hovered_task_id: null })}
        >
        <Row>
          <Col
            md={2}
            xs={2}
            style={{
              color: new Date() < new Date(task.due_date) ? '#1AAE88' : '#D2312D',
              paddingRight: '0px',
              width: '10%'
            }}
            >
            <i className='fa fa-circle' style={{ display: task.completed ? 'none' : 'block' }}/>
          </Col>
          <Col md={8} xs={8}>
            <Row>
              <Col md={12} xs={12} style={{ color: 'white' }}>
                <div onClick={() => this.handleClickTask(task._id)}>
                  {this.state.current_task_id != task._id ? (
                    <Dotdotdot clamp={2}>
                      <p style={{ marginBottom: '3px' }}>{task.text}</p>
                    </Dotdotdot>
                  ) : (
                    <p style={{ marginBottom: '3px' }}>{task.text}</p>
                  )}
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={12} xs={12} className='task-data'>
                <p
                  className='text-muted'
                  style={{ marginBottom: '0px', marginTop: '5px' }}
                  >
                  {this.props.show_assigned_by_me ? 'Assigned To : ' : 'Assigned By : '}
                  {user_name}
                </p>
                {task.client ?
                <p className='text-muted' style={{ marginBottom: '0px' }}>Client :{'  '}
                  <Link to={`client/${task.client._id}`}>{task.client.name && task.client.name != '' ? task.client.name : '(No Name)'}</Link>
                </p> :
                null}
                {task.due_date ? <p className='text-muted'>Due : {moment(task.due_date).utc().format('ddd MMM Do, YYYY')}</p> : null}
                {!this.props.show_assigned_by_me && task.reminder_date ? (
                  <p className='text-muted'>Reminder : {moment(task.reminder_date).utc().format('MMM Do, YYYY, h:mm a')}</p>
                ) : null}
              </Col>
            </Row>
          </Col>
          <Col md={2} xs={2}>
            {this.state.current_hovered_task_id == task._id ? (
              <div className='animated fadeIn task-options-container'>
                {this.props.show_assigned_by_me ? (
                  <i className='fa fa-pencil task-options-button' onClick={() => this.initEditTask(task)} />
                ) : (
                  <i className='fa fa-check task-options-button' onClick={() => this.toggleTaskComplete(task)} />
                )}
                <i className='fa fa-times task-options-button' onClick={() => this.promptDeleteTask(task._id) }/>
                {!this.props.show_assigned_by_me ? (
                  <i className='fa fa-clock-o task-options-button' onClick={() => this.props.initEditReminderDate(task)} />
                ) : null}
              </div>
            ) : null}
          </Col>
        </Row>
      </li>
    );
  }

  render() {
    const sorted_tasks = [ ...this.props.tasks ].sort((a, b) => a.due_date < b.due_date ? -1 : 1);
    return sorted_tasks.length == 0 ? (
      <h4>No Tasks</h4>
    ) : (
      <div className='tasks-sidebar-list-container'>
        <ul>{sorted_tasks.map(t => this.renderTask(t))}</ul>

        <ConfirmationPrompt
          show_condition={this.state.show_delete_task_prompt}
          handleCancelPrompt={() => this.setState({ show_delete_task_prompt: false })}
          handleConfirmPrompt={this.handleDeleteTask}
          type='danger'
          title='Delete Task?'
          body='Are you sure you want to delete this task?'
          confirm_button_text='Delete'
        />
      </div>
    );
  }
}

const mapStateToProps = ({ users }) => ({ users });

export default connect(mapStateToProps, { sendSocketEmit })(TasksSidebarList);



// WEBPACK FOOTER //
// ./src/browser/components/tasks/new-tasks/tasks-sidebar-list.js